module.exports = __webpack_public_path__ + "static/img/img_guide1.36133340.png";